export const isNodeOrNull=value=>null===value||value instanceof Node;